"use client";
import { useEffect, createContext, useState, useRef } from "react";
import { usePathname } from "next/navigation";
import { initAmplitude } from "@/services/AmplitudeService/AmplitudeService";
import { QRType } from "@/types/qr";
import { scheduleIdle } from "@/utils/browser";
import { isStripeCriticalPath } from "@/internals/constants/paths";
import { IAmplitudeContext } from "./types";

export const AmplitudeContext = createContext<IAmplitudeContext>(undefined);
export const AmplitudeContextProvider = ({ children }) => {
  const [source, setSource] = useState("");
  const [qrSelected, setQrSelected] = useState<QRType | undefined>();
  const [data, setData] = useState();
  const initialized = useRef(false);

  const pathname = usePathname();
  useEffect(() => {
    if (initialized.current) return;
    // Only defer Amplitude init on Stripe-critical routes so it doesn't
    // steal CPU/network from the ECE boot
    const run = () => {
      initialized.current = true;
      initAmplitude();
    };
    if (!isStripeCriticalPath(pathname)) {
      run();
      return;
    }
    const cancel = scheduleIdle(run, 3000);
    return cancel;
  }, [pathname]);

  const value = {
    source,
    setSource,
    data,
    setData,
    qrSelected,
    setQrSelected,
  };

  return <AmplitudeContext.Provider value={value}>{children}</AmplitudeContext.Provider>;
};
